// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageSlider_ImagesliderContainer__qY0He {
  display: flex;
}

.ImageSlider_swiper_slide__ppzMH {
  width: 100% !important;
  /* Adjust the width based on screen size */
}

.ImageSlider_previosbutton__mshfp {
  color: black;
  position: absolute;
  left: 0px;
  bottom: 50%;
  padding: 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  z-index: 5;
}
.ImageSlider_previosbutton__mshfp:hover {
  background-color: rgba(128, 128, 128, 0.3607843137);
}

.ImageSlider_nextbutton__xHVNA {
  color: black;
  position: absolute;
  right: 0px;
  bottom: 50%;
  padding: 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  z-index: 5;
}

.ImageSlider_newButton__6FUGR {
  background-color: var(--borderColor) !important;
  border-radius: 50% !important;
  width: 30px !important;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.ImageSlider_miniSliderHover__ma5V6:hover {
  background-color: rgba(128, 128, 128, 0.3607843137);
}

.ImageSlider_tweetImageUrl__4dL2b {
  position: relative;
  margin-bottom: 10px;
  text-align: center;
}
.ImageSlider_tweetImageUrl__4dL2b .ImageSlider_VideoBtn__vTjw2 {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bgColor);
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondaryColor);
}

.ImageSlider_swiper-button-prev__z48vq {
  z-index: 5;
  color: green !important;
}

.ImageSlider_swiper-0__tfJmV .ImageSlider_swiper-button-next__Op23u {
  z-index: 5;
  color: green !important;
}

.ImageSlider_hidden__WmZgG {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ImageSlider/ImageSlider.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,0CAAA;AACF;;AASA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;AANF;AAOE;EACE,mDAAA;AALJ;;AAQA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;AALF;;AAOA;EACE,+CAAA;EACA,6BAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,mDAAA;AAJF;;AAOA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AAJF;AAKE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAHJ;;AAOA;EACE,UAAA;EACA,uBAAA;AAJF;;AAOA;EACE,UAAA;EACA,uBAAA;AAJF;;AAMA;EACE,aAAA;AAHF","sourcesContent":[".ImagesliderContainer {\n  display: flex;\n}\n\n.swiper_slide {\n  width: 100% !important;\n  /* Adjust the width based on screen size */\n}\n\n.swiper-Comp {\n  .swiper-button-next {\n    button {\n    }\n  }\n}\n\n.previosbutton {\n  color: black;\n  position: absolute;\n  left: 0px;\n  bottom: 50%;\n  padding: 10px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  z-index: 5;\n  &:hover {\n    background-color: #8080805c;\n  }\n}\n.nextbutton {\n  color: black;\n  position: absolute;\n  right: 0px;\n  bottom: 50%;\n  padding: 10px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  z-index: 5;\n}\n.newButton {\n  background-color: var(--borderColor) !important;\n  border-radius: 50% !important;\n  width: 30px !important;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  // right: 30px;\n}\n.miniSliderHover:hover {\n  background-color: #8080805c;\n}\n\n.tweetImageUrl {\n  position: relative;\n  margin-bottom: 10px;\n  text-align: center;\n  .VideoBtn {\n    position: absolute;\n    display: block;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--bgColor);\n    width: 37px;\n    height: 37px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondaryColor);\n  }\n}\n\n.swiper-button-prev {\n  z-index: 5;\n  color: green !important;\n}\n\n.swiper-0 .swiper-button-next {\n  z-index: 5;\n  color: green !important;\n}\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ImagesliderContainer": `ImageSlider_ImagesliderContainer__qY0He`,
	"swiper_slide": `ImageSlider_swiper_slide__ppzMH`,
	"previosbutton": `ImageSlider_previosbutton__mshfp`,
	"nextbutton": `ImageSlider_nextbutton__xHVNA`,
	"newButton": `ImageSlider_newButton__6FUGR`,
	"miniSliderHover": `ImageSlider_miniSliderHover__ma5V6`,
	"tweetImageUrl": `ImageSlider_tweetImageUrl__4dL2b`,
	"VideoBtn": `ImageSlider_VideoBtn__vTjw2`,
	"swiper-button-prev": `ImageSlider_swiper-button-prev__z48vq`,
	"swiper-0": `ImageSlider_swiper-0__tfJmV`,
	"swiper-button-next": `ImageSlider_swiper-button-next__Op23u`,
	"hidden": `ImageSlider_hidden__WmZgG`
};
export default ___CSS_LOADER_EXPORT___;
